import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const SETTINGS = {
  todo_list: ['mdi-format-list-checks'],
  image: ['mdi-image', 'Добавить картинку'],
  link: ['mdi-link', 'Добавить ссылку', 'Изменить ссылку'],
  table: ['mdi-table', 'Таблица'],
  blockquote: ['mdi-format-quote-close', 'Блок цитаты'],
  bold: ['mdi-format-bold', 'Жирный'],
  bullet_list: ['mdi-format-list-bulleted', 'Маркированный список'],
  code: ['mdi-code-tags', 'Код'],
  code_block: ['mdi-code-not-equal-variant', 'Блок кода'],
  // hard_break: ['mdi-format-page-break', 'HardBreak'],
  // heading: ['H1'],
  undo: ['mdi-undo', 'Назад'],
  redo: ['mdi-redo', 'Вперед'],
  horizontal_rule: ['mdi-minus', 'Горизонтальная линия'],
  italic: ['mdi-format-italic', 'Курсивный'],
  // ListItem: ['ListItem'],
  ordered_list: ['mdi-format-list-numbered', 'Упорядоченный список'],
  // paragraph: ['mdi-format-paragraph', 'Параграф'],
  strike: ['mdi-format-strikethrough', 'Перечерктнутый'],
  underline: ['mdi-format-underline', 'Подчерктнутый'],

  alignment: {
    left: ['mdi-format-align-left', 'Выровнять по левому краю'],
    right: ['mdi-format-align-right', 'Выровнять по правому краю'],
    center: ['mdi-format-align-center', 'Выровнять по центру'],
    justify: ['mdi-format-align-justify', 'Выровнять по ширине'],
  },
  color: ['mdi-format-color-fill', 'Цвет текста'],
  color_bg: ['mdi-format-color-highlight', 'Цвет выделенного текста'],

  excel_cell: ['mdi-microsoft-excel', 'Добавить ячейки', 'Изменить ячейку'],

  code_view: ['mdi-file-code-outline', 'Просмотр кода', 'Отключить просмотр кода'],
}

export const SETTINGS_TABLE = {
  createTable: ['mdi-table', 'Таблица'],
  deleteTable: ['mdi-table-cancel', 'Удалить таблицу'],
  addColumnAfter: ['mdi-table-arrow-right', 'Добавить колонку'],
  deleteColumn: ['mdi-table-arrow-left', 'Удалить колонку'],
  addRowAfter: ['mdi-table-arrow-down', 'Добавить строку'],
  deleteRow: ['mdi-table-arrow-up', 'Удалить строку'],
}

export const createEditorModalLink = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BEditorModalLink" */
    './BEditorModalLink.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createEditorModalImage = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BEditorModalImage" */
    './BEditorModalImage.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createBEditorModalExcelCell = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BEditorModalExcelCell" */
    './BEditorModalExcelCell.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
